import { GlSprintf, GlLink } from '@gitlab/ui';
import { EVENT_COMMENTED_I18N, EVENT_COMMENTED_SNIPPET_I18N, VARIANT_DEFAULT } from 'ee_else_ce/contribution_events/constants';
import { SNIPPET_NOTEABLE_TYPE, COMMIT_NOTEABLE_TYPE } from '~/notes/constants';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { isValidVariant } from '../../utils';
import ResourceParentLink from '../resource_parent_link.vue';
import ContributionEventBase from './contribution_event_base.vue';
export default {
    name: 'ContributionEventCommented',
    components: {
        ContributionEventBase,
        GlSprintf,
        GlLink,
        ResourceParentLink
    },
    directives: {
        SafeHtml
    },
    props: {
        event: {
            type: Object,
            required: true
        },
        variant: {
            type: String,
            required: false,
            default: VARIANT_DEFAULT,
            validator: isValidVariant
        }
    },
    computed: {
        resourceParent () {
            return this.event.resource_parent;
        },
        noteable () {
            return this.event.noteable;
        },
        noteableType () {
            return this.noteable.type;
        },
        message () {
            if (this.noteableType === SNIPPET_NOTEABLE_TYPE) {
                return EVENT_COMMENTED_SNIPPET_I18N[this.resourceParent?.type] || EVENT_COMMENTED_SNIPPET_I18N.fallback;
            }
            return EVENT_COMMENTED_I18N[this.noteableType] || EVENT_COMMENTED_I18N.fallback;
        },
        noteableLinkClass () {
            if (this.noteableType === COMMIT_NOTEABLE_TYPE) {
                return [
                    'gl-font-monospace'
                ];
            }
            return [];
        }
    }
};
